import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
import { ErrorFragmentDoc } from '../../fragments/__generated__/Error.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SubmissionAnalyticsMutationVariables = Types.Exact<{
  submission: Types.Scalars['ID']['input'];
  event: Types.Scalars['String']['input'];
  activationCode: Types.Scalars['String']['input'];
}>;


export type SubmissionAnalyticsMutation = { submissionAnalytics: { errors: Array<{ field: string, messages: Array<string> }> } };


export const SubmissionAnalyticsDocument = gql`
    mutation SubmissionAnalytics($submission: ID!, $event: String!, $activationCode: String!) {
  submissionAnalytics(
    submission: $submission
    event: $event
    activationCode: $activationCode
  ) {
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type SubmissionAnalyticsMutationFn = Apollo.MutationFunction<SubmissionAnalyticsMutation, SubmissionAnalyticsMutationVariables>;

/**
 * __useSubmissionAnalyticsMutation__
 *
 * To run a mutation, you first call `useSubmissionAnalyticsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmissionAnalyticsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submissionAnalyticsMutation, { data, loading, error }] = useSubmissionAnalyticsMutation({
 *   variables: {
 *      submission: // value for 'submission'
 *      event: // value for 'event'
 *      activationCode: // value for 'activationCode'
 *   },
 * });
 */
export function useSubmissionAnalyticsMutation(baseOptions?: Apollo.MutationHookOptions<SubmissionAnalyticsMutation, SubmissionAnalyticsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmissionAnalyticsMutation, SubmissionAnalyticsMutationVariables>(SubmissionAnalyticsDocument, options);
      }
export type SubmissionAnalyticsMutationHookResult = ReturnType<typeof useSubmissionAnalyticsMutation>;
export type SubmissionAnalyticsMutationResult = Apollo.MutationResult<SubmissionAnalyticsMutation>;
export type SubmissionAnalyticsMutationOptions = Apollo.BaseMutationOptions<SubmissionAnalyticsMutation, SubmissionAnalyticsMutationVariables>;